var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary","disabled":!_vm.creatable},on:{"click":_vm.create}},[_c('b-icon',{attrs:{"icon":"plus"}}),_vm._v(" 作成 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }